import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { urlEndPoint } from 'src/app/common';
import { ActivatedRoute, Router } from '@angular/router';
import { PublicationService } from 'src/app/services/obs/publication.service';
import { UploadfileService } from 'src/app/services/util/uploadfile.service';
import { TematicService } from 'src/app/services/obs/tematic.service';
import { ResponseTematic } from 'src/app/models/obs/apiResponse';
import { Tematic } from 'src/app/models/obs/tematic';
import { Message } from 'src/app/models/message';
import { ErrorHandlingService } from 'src/app/services/util/error-handling.service';
import { PubTematic } from 'src/app/models/obs/pubtematic';
import { PubtematicService } from 'src/app/services/obs/pubtematic.service';
import { Classification } from 'src/app/models/obs/classification';
import { PubClassif } from 'src/app/models/obs/pubclassif';
import { ClassificationService } from 'src/app/services/obs/classification.service';
import { PubclassifService } from 'src/app/services/obs/pubclassif.service';
import { Publication } from 'src/app/models/obs/publication';
import { Log } from 'src/app/models/user-log';
import { UserLogService } from 'src/app/services/user-log.service';
import { UtilLogService } from 'src/app/services/util/util-log.service';
import { AccessService } from 'src/app/services/access.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';

@Component({
  selector: 'app-admpublications-form',
  templateUrl: './admpublications-form.component.html',
  styleUrl: './admpublications-form.component.scss'
})
export class AdmpublicationsFormComponent implements OnInit {

  form: FormGroup;
  publication: Publication = null;
  msg: Message;

  edit: boolean = false;
  idpubclasif: number;
  isUploadDir: boolean = false;
  filename: string = null;
  URL: string = urlEndPoint;
  uploatedFile: File;

  temdata: Tematic[];
  clasdata: Classification[];
  tematicToDelete: number;
  showDeleteConfirmationTematic = false;

  dataLog = {};
  movesLog: Log[] = null;
  accessMP: boolean = false;
  inf = {}
  constructor(
    private accesService: AccessService,
    private ts: TokenStorageService,
    private router: Router,
    private publicationService: PublicationService,
    private pubtematicService: PubtematicService,
    private classificationService: ClassificationService,
    private pubclassifService: PubclassifService,
    private fb: FormBuilder,
    private activedRoute: ActivatedRoute,
    private userLogService: UserLogService,
    private utilLogservice: UtilLogService,
    private uploadS: UploadfileService,
    private tematicsService: TematicService,
    private errorService: ErrorHandlingService,
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.getClasifications();
    this.getTematics();
    this.createForm();
    this.getPublication(params);
    this.getPermission();
  }

  createForm() {
    this.form = this.fb.group({
      id: [null],
      name: ['', Validators.required],
      shortname: ['', Validators.required],
      year: [null],
      publication_date: ['', Validators.required],
      description: [null],
      urlfile: [null],
      urlimg: [null],
      team: ['', Validators.required],
      pages: [0, Validators.required],
      editorial: ['', Validators.required],
      appointment: [''],
      contents: [''],
      language: [0, Validators.required],
      status: [true],
      tematics: this.fb.array([]),
      selectedTematic: [null],
      idclasification: [null]
    })
    this.getYear();
  }

  getYear() {
    // Suscribirse a cambios en publication_date para actualizar year
    this.form.get('publication_date').valueChanges.subscribe((publicationDate) => {
      if (publicationDate) {
        const year = new Date(publicationDate).getFullYear();
        this.form.get('year').patchValue(year);
      }
    });
  }

  getTematics() {
    this.tematicsService.getAll().subscribe({
      next: async ({ data }: any) => { this.temdata = data; },
      error: err => { this.msg = this.errorService.handleError(err); }
    });
  }

  /* Cargar data de tematic para el combo */
  getClasifications() {
    this.classificationService.getAll().subscribe({
      next: async ({ data }: ResponseTematic) => { this.clasdata = data; },
      error: err => { this.msg = this.errorService.handleError(err); }
    });
  }


  getClasificationsRelations(id: number) {
    this.pubclassifService.getByPublication((id).toString()).subscribe({
      next: (res: any) => {
        if (res && res.data && res.data.length > 0) {
          this.idpubclasif = res.data[0].id;
          this.form.get('idclasification').setValue(res.data[0].idclassification);
        } else {
          this.form.get('idclasification').setValue(null);
        }
      },
      error: err => {
        this.msg = this.errorService.handleError(err);
      }
    });
  }

  addTematic() {
    const selectedTematic = this.form.get('selectedTematic').value;
    if (selectedTematic) {
      const selectedTematics = this.form.get('tematics') as FormArray;
      selectedTematics.push(this.fb.group({
        idtematic: selectedTematic.id,
        title: selectedTematic.title,
      }));
    }
  }

  get selectedTematicsControls() {
    return this.form.get('tematics') as FormArray;
  }

  removeTematic(index: number) {
    const selectedTematics = this.form.get('tematics') as FormArray;
    selectedTematics.removeAt(index);
  }

  triggerDeleteTematicConfirmation(i: number) {
    this.tematicToDelete = i;
    this.showDeleteConfirmationTematic = true;
  }

  confirmDeleteTematic() {
    this.selectedTematicsControls.removeAt(this.tematicToDelete);
    this.showDeleteConfirmationTematic = false;
  }

  cancelDeleteTematic() {
    this.showDeleteConfirmationTematic = false;
  }

  verifiedImgDirectory() {
    if (this.publication.urlimg != null) {
      (this.publication.urlimg.substr(1, 6) === 'upload') ? this.isUploadDir = true : this.isUploadDir = false;
    }
  }

  getPublication(params: any) {
    if (params.id) {
      this.publicationService.getOne(params.id).subscribe({
        next: res => {
          this.publication = res['data'];
          this.getLog();
          this.verifiedImgDirectory();
          this.edit = true;
          this.loadData();
          if (this.publication) {
            this.getPublicationRelations(params.id);
            this.getClasificationsRelations(params.id);
          }
        },
        error: err => console.error(err)
      });
    } else {
      this.edit = false;
    }
  }

  getPublicationRelations(id: string) {
    this.tematicsService.getAllByIdPub(id).subscribe({
      next: ({ data }: ResponseTematic) => {
        this.publication.tematics = data;
        const selectedTematicsArray = this.fb.array([]);
        this.publication.tematics.forEach(tematics => {
          selectedTematicsArray.push(this.fb.control(tematics));
        });
        this.form.setControl('tematics', selectedTematicsArray);
        this.loadDataPublicationRelations();
      },
      error: err => { this.msg = this.errorService.handleError(err); }
    });
  }


  loadDataPublicationRelations() {
    while ((this.form.get('tematics') as FormArray).length !== 0) {
      (this.form.get('tematics') as FormArray).removeAt(0);
    }
    if (this.publication.tematics && this.publication.tematics.length > 0) {
      this.publication.tematics.forEach((selectedTematic: Tematic) => {
        const selectedTematicFormGroup = this.fb.group({
          idtematic: [selectedTematic.id],
          title: [selectedTematic.title]
        });
        (this.form.get('tematics') as FormArray).push(selectedTematicFormGroup);
      });
    }
  }

  loadData() {
    this.form.reset(this.publication);
  }

  onFileChange(e) {
    this.uploatedFile = e.target.files;
    const reader = new FileReader();
    reader.onload = (e) => {
      this.form.get('urlimg').setValue(e.target['result']);
    };
    reader.readAsDataURL(this.uploatedFile[0]);
  }

  cancel() {
    this.router.navigate(['/adm/publicacion/list']);
  }

  save() {
    if (this.form.invalid) {
      console.log("Formulario inválido");
      return Object.values(this.form.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      (this.uploatedFile != null) ? this.onUpload() : this.saveOrUpdate();
    }
  }

  onUpload() {
    let formData = new FormData();
    formData.append("uploads", this.uploatedFile[0], this.uploatedFile[0].name);
    this.uploadS.uploadFileImgPubs(formData).subscribe((res) => {
      this.filename = res['filename'];
      this.saveOrUpdate();
    });
  }

  saveOrUpdate() {
    this.edit ? this.update(this.form.value.id, this.form.value) : this.create(this.form.value);
    this.router.navigate(['/adm/publicacion/list']);
  }

  create(publication: Publication) {
    delete publication.id;
    if (this.filename) { publication.urlimg = '/uploads/' + this.filename; }
    this.publicationService.create(publication).subscribe({
      next: res => {
        if (res) {
          this.createRelations(res.id);
          this.createRelClassi(res.id);
          this.utilLogservice.createLog(res, 'creación', 'Lista publicacion');
        }
      },
      error: err => { console.error(err) }
    });
  }

  createRelations(newId: number) {
    const selectedRelations: PubTematic[] = this.form.get('tematics').value;
    for (let relation of selectedRelations) {
      relation.idpublication = newId;
      relation.status = true;
      this.pubtematicService.create(relation).subscribe({
        next: res => console.log("relation created: ", res),
        error: err => console.error(err)
      });
    }
  }

  createRelClassi(newId: number) {
    const newRelClassi: PubClassif = {
      idpublication: newId,
      idclassification: this.form.get('idclasification').value,
      status: true
    };

    this.pubclassifService.create(newRelClassi).subscribe({
      next: res => console.log("relation created: ", res),
      error: err => console.error(err)
    })

  }

  update(id: string, publication: Publication) {
    const data = { ...publication };
    delete publication.id;
    if (this.filename) { publication.urlimg = '/uploads/' + this.filename; }
    this.publicationService.update(id, publication).subscribe({
      next: res => {
        this.updateRelations(Number(id));
        this.idpubclasif ? this.updateRelClassi(Number(id)) : this.createRelClassi(Number(id));
        if (res) this.utilLogservice.createLog(data, 'edición', 'Lista publicacion');
      },
      error: err => { console.error(err) }
    });
  }

  updateRelations(newId: number) {
    const oldRelations: PubTematic[] = this.publication.tematics.map((tematic: Tematic) => {
      return {
        idpublication: newId,
        idtematic: tematic.id,
        status: true
      };
    });

    this.pubtematicService.deleteRelationships(oldRelations).subscribe({
      next: delRes => {
        const newRelations: PubTematic[] = this.form.get('tematics').value;
        for (let relation of newRelations) {
          relation.idpublication = newId;
          relation.status = true;
          this.pubtematicService.create(relation).subscribe({
            next: res => console.log("relation created: ", res),
            error: err => console.error(err)
          });
        }
      },
      error: delErr => { console.error(delErr) }
    })

  }

  updateRelClassi(newId: number) {
    if (typeof this.idpubclasif === 'number' && !isNaN(this.idpubclasif)) {
      const newRelClassi: PubClassif = {
        id: this.idpubclasif,
        idpublication: newId,
        idclassification: this.form.get('idclasification').value,
        status: true
      };

      this.pubclassifService.update(this.idpubclasif.toString(), newRelClassi).subscribe({
        next: res => console.log("relation updated: ", res),
        error: err => console.error(err)
      });
    } else {
      console.error("no es un indice  válido");
    }
  }

  campoNoValido(campo: string) {
    return this.form.get(campo).invalid && this.form.get(campo).touched;
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault(); // Evitar el salto de línea predeterminado
      this.formatContent();
    }
  }

  formatContent() {
    const contentsControl = this.form.get('contents');
    if (contentsControl) {
      let contentsValue = contentsControl.value;
      const lines = contentsValue.split('\n');
      let formattedContent = '';

      for (let i = 0; i < lines.length; i++) {
        if (lines[i]) {
          formattedContent += lines[i] + '<br>';
          if (i < lines.length - 1) {
            formattedContent += '\n'; // Agregar un salto de línea entre elementos
          }
        }
      }
      contentsControl.setValue(formattedContent);
    }
  }

  /* Obtener ultimos moviemientos de los usuarios en el compoente */
  getLog() {
    const term = this.activedRoute.snapshot['_routerState'].url.split('/')[2];
    const idContent = this.activedRoute.snapshot.params['id'];
    this.userLogService.getLastLogByContent(idContent, term).subscribe({
      next: res => { this.movesLog = res['data'] || []; },
      error: err => console.error(err)
    });
  }

  getPermission() {
    this.inf['userId'] = this.ts.getUser().id;
    this.inf['accessId'] = 12;//este id es del modulo de reportes
    const data = this.inf;
    this.accesService.getPermissionUser(data).subscribe({
      next: res => {
        this.accessMP = res['result'] ? true : false;
      }
    });
  }

}
